export const SITE_URL = "https://hector-project.com";  //195.251.95.14:2002 

export const API_URL = "https://hector-project.com/api"; //195.251.95.14:2002 

export const API_SERVER_URL = "https://hector-project.com"; //195.251.95.14:2002

export const AUTH_SERVICE_URL = "https://hector-project.com/api/auth/"; //195.251.95.14:2002 

export const USER_SERVICE_URL = "https://hector-project.com/api/test/"; //195.251.95.14:2002 

export const ELEARNING_AUTH_URL = "https://hector-project.com/api/elearning/auth/";

export const ELEARNING_API_URL = "https://hector-project.com/api/elearning/";
